import { RetailerApiClient } from '@/services/RetailerApiClient.js'

export default {
  getUnits() {
    return RetailerApiClient.get('units')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getUnitsByProduct(productId) {
    return RetailerApiClient.get('products/' + productId + '/units')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
